import _ from 'lodash'
import { useEffect, useState } from 'react'

import useUnitFiltersConfig from './useUnitFiltersConfig'

const useUnitFilter = () => {
  const [unitFilter, setUnitFilter] = useState<string[]>([])

  const unitFiltersConfig = useUnitFiltersConfig()
  const { unitFilters, initialUnit } = unitFiltersConfig

  useEffect(() => {
    setUnitFilter([initialUnit || unitFilters[1].value])
  }, [unitFilters])

  return {
    unitFilter,
    setUnitFilter,
    unitFilters,
  }
}

export default useUnitFilter
